// NetworkStatus was copied directly from the @apollo/client package because we're currently using the older react-apollo
// packages which are not compatible with @apollo/client. Once we switch everything fully to @apollo/client, we can use the built in NetworkStatus.
// import { NetworkStatus } from '@apollo/client';
// See https://github.com/apollographql/apollo-client/blob/d96f4578f89b933c281bb775a39503f6cdb59ee8/src/core/networkStatus.ts
export default {
  loading: 1,
  setVariables: 2,
  fetchMore: 3,
  refetch: 4,
  poll: 6,
  ready: 7,
  error: 8
};
